import './index.scss';
import classNames from 'classnames';
import React from 'react';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useRecentActivity } from '../../providers';
import ActivityGrid from '../activity_grid';
const ComparisonsTab = () => {
    const { hasPermission } = useUser();
    const { comparisons } = useRecentActivity();
    const hasMultipleTabs = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS) &&
        hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS);
    const containerClasses = classNames('empty-comparison-activity-container', {
        'with-tabs': hasMultipleTabs,
    });
    if ((comparisons === null || comparisons === void 0 ? void 0 : comparisons.length) === 0) {
        return (React.createElement("div", { className: containerClasses },
            React.createElement("i", { className: 'empty-comparison-svg' }),
            React.createElement("div", { className: 'empty-heading' }, "No recent comparisons"),
            React.createElement("div", { className: 'empty-sub-heading' }, "A history of comparisons you create and view will display here")));
    }
    return React.createElement(ActivityGrid, { recentComparisonActivities: comparisons, recentDocumentActivities: null });
};
export default ComparisonsTab;
